module.exports = __webpack_public_path__ + "static/img/hero_preview-2.2aa5f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/hero_preview-2.png
// module id = BGjO
// module chunks = 0